import { render } from "./GrupoDescClientes.vue?vue&type=template&id=7ab0a398&scoped=true"
import script from "./GrupoDescClientes.vue?vue&type=script&lang=js"
export * from "./GrupoDescClientes.vue?vue&type=script&lang=js"

import "./GrupoDescClientes.vue?vue&type=style&index=0&id=7ab0a398&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab0a398"]])

export default __exports__